export const UserRole = {
	USER: "ROLE_USER",
	ADMIN: "ROLE_ADMIN",
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const ResourceRole = {
	OWNER: "OWNER",
	ADMIN: "ADMIN",
	MAINTAINER: "MAINTAINER",
	/** What a share grants since the model rework: work on it. */
	EDITOR: "EDITOR",
	USER: "USER",
	VIEWER: "VIEWER",
} as const;

export type ResourceRole = (typeof ResourceRole)[keyof typeof ResourceRole];

// Ordered highest → lowest — used by isSup()
export const RESOURCE_ROLES: ResourceRole[] = [
	ResourceRole.OWNER,
	ResourceRole.ADMIN,
	ResourceRole.MAINTAINER,
	ResourceRole.EDITOR,
	ResourceRole.USER,
	ResourceRole.VIEWER,
];

/** What one grants on a client or a project today; the rest are read from older rows. */
export const GRANTABLE_ROLES: Exclude<ResourceRole, "OWNER">[] = [
	ResourceRole.EDITOR,
	ResourceRole.VIEWER,
];

/** What one grants across a workspace. NONE belongs and sees nothing by itself. */
export const WORKSPACE_ROLES = ["ADMIN", "EDITOR", "VIEWER", "NONE"] as const;

export type TWorkspaceRole = "OWNER" | (typeof WORKSPACE_ROLES)[number];
